import { type ReactNode } from "react";
import { NavLink } from "react-router-dom";

type StaffHeaderIconButtonProps = {
  "aria-label": string;
  children: ReactNode;
  className?: string;
  to?: string;
  onClick?: () => void;
  type?: "button";
};

/** 44×44 staff header control — icon-only, consistent with theme toggle. */
export function StaffHeaderIconButton({
  "aria-label": ariaLabel,
  children,
  className = "",
  to,
  onClick,
}: StaffHeaderIconButtonProps) {
  const classes = `staff-header-btn${className ? ` ${className}` : ""}`;

  if (to) {
    return (
      <NavLink to={to} className={classes} aria-label={ariaLabel}>
        {children}
      </NavLink>
    );
  }

  return (
    <button type="button" className={classes} aria-label={ariaLabel} onClick={onClick}>
      {children}
    </button>
  );
}
